export const identity = {
  identityFormTitle: "完善您的资料",
  identityFormDescription: "请输入您的身份证件以继续。",
  identityFormSubmit: "继续",
  identityFormSave: "保存并继续",
  identityFormVerifying: "查询中...",
  identityFormSaving: "保存中...",
  identityFormErrorTitle: "无法完成",
  identityCedulaLabel: "证件类型和号码",
  identityIdTypeLabel: "证件类型",
  identityCedulaRequired: "请输入您的证件号码",
  identityCedulaLength: "必须包含6到10位数字",
  identityRutPlaceholder: "12345678-9",
  identityRutRequired: "请输入您的智利RUT",
  identityRutInvalid: "请输入有效的智利RUT（格式：12345678-9）",
  identityFirstNameLabel: "名字",
  identityFirstNamePlaceholder: "您的名字",
  identityFirstNameRequired: "请输入您的名字",
  identityLastNameLabel: "姓氏",
  identityLastNamePlaceholder: "您的姓氏",
  identityLastNameRequired: "请输入您的姓氏",
  identityBirthdateLabel: "出生日期",
  identityBirthdatePlaceholder: "选择您的出生日期",
  identityBirthdateRequired: "请输入您的出生日期",
  identityManualFallbackHint: "我们无法自动验证您的身份证。请手动填写您的资料以继续。",
  identityChangeCedula: "更改证件",
  identityVerifiedLabel: "证件已验证",

  identityError_generic: "无法完成您的注册。请重试。",
  identityError_invalid_document: "证件格式无效。",
  identityError_underage: "您必须年满18岁才能注册。",
  identityError_document_not_found: "在民事登记处未找到您的身份证。",
  identityError_document_already_registered: "此身份证已注册。请使用现有账户登录。",
  identityError_verification_expired: "验证已过期。请重新输入您的身份证。",
  identityError_verification_invalid: "验证无效。请重新输入您的身份证。",
  identityError_verification_required: "在使用Google继续之前，您必须验证您的身份证。",
  identityError_kyc_unavailable: "验证服务不可用。请稍后再试。",
  identityError_rate_limit_exceeded: "尝试次数过多。请等待几分钟后重试。",

  onboardingModalTitle: "完善您的资料",
  onboardingContinue: "继续",
  onboardingBack: "返回",
  onboardingLater: "稍后再说",
  onboardingConfirm: "确认并保存",
  onboardingPagoMovilTitle: "Pago Móvil",
  onboardingPagoMovilDescription: "添加您的银行和电话以进行玻利瓦尔存款和取款。",
  onboardingPhoneDigits: "请输入电话号码剩余的7位数字",
  onboardingSuccessTitle: "资料已完成",
  onboardingSuccessMessage: "您的身份和Pago Móvil账户已设置。",
  onboardingSuccessProfileOnly: "您的资料已成功保存。",
  onboardingErrorTitle: "无法完成注册",
  onboardingErrorMessage: "请检查您的信息并重试。",
  onboardingReferralWarningTitle: "推荐码未应用",
};
